import axios from "../utils/axios";

export const getBlogs = async (params) => {
    try {
        const { data } = await axios.get('/blogs', { params });
        return data;
    } catch (error) {
        console.error("~ getBlogs ~ error:", error);
        throw error;
    }
};

export const getBlogById = async (id) => {
    try {
        const { data } = await axios.get(`/blogs/${id}`);
        return data;
    } catch (error) {
        console.error("~ getBlogById ~ error:", error);
        throw error;
    }
};

export const createBlog = async (blogData) => {
    try {
        const { data } = await axios.post('/blogs', blogData);
        return data;
    } catch (error) {
        console.error("~ createBlog ~ error:", error);
        throw error;
    }
};

export const updateBlog = async (id, blogData) => {
    try {
        const { data } = await axios.put(`/blogs/${id}`, blogData);
        return data;
    } catch (error) {
        console.error("~ updateBlog ~ error:", error);
        throw error;
    }
};

export const deleteBlog = async (id) => {
    try {
        const { data } = await axios.delete(`/blogs/${id}`);
        return data;
    } catch (error) {
        console.error("~ deleteBlog ~ error:", error);
        throw error;
    }
};

export const forceDeleteBlog = async (id) => {
    try {
        const { data } = await axios.delete(`/blogs/${id}/force-delete`);
        return data;
    } catch (error) {
        console.error("~ forceDeleteBlog ~ error:", error);
        throw error;
    }
};

export const restoreBlog = async (id) => {
    try {
        const { data } = await axios.post(`/blogs/${id}/restore`);
        return data;
    } catch (error) {
        console.error("~ restoreBlog ~ error:", error);
        throw error;
    }
};

export const massDestroyBlogs = async (data) => {
    try {
        const response = await axios.delete('/blogs/mass-destroy', { data });
        return response.data;
    } catch (error) {
        console.error("~ massDestroyBlogs ~ error:", error);
        throw error;
    }
};

export const massForceDeleteBlogs = async (data) => {
    try {
        const response = await axios.delete('/blogs/mass-force-delete', { data });
        return response.data;
    } catch (error) {
        console.error("~ massForceDeleteBlogs ~ error:", error);
        throw error;
    }
};

export const massRestoreBlogs = async (data) => {
    try {
        const response = await axios.post('/blogs/mass-restore', data);
        return response.data;
    } catch (error) {
        console.error("~ massRestoreBlogs ~ error:", error);
        throw error;
    }
};
